import { useIsInsideRoom, useMyPresence } from "@liveblocks/react"
import type { ReactNode } from "react"

interface CollaborationPresenceProps {
  children: ReactNode
  id: string
}

export function CollaborationPresence(props: CollaborationPresenceProps) {
  const isInsideRoom = useIsInsideRoom()

  if (!isInsideRoom) return <>{props.children}</>

  return <CollaborationPresenceInner {...props} />
}

function CollaborationPresenceInner(props: CollaborationPresenceProps) {
  const { id, children } = props
  const [_, updatePresence] = useMyPresence()

  return (
    <div
      // This div is used to track bubbled focus for the presence update
      // It is not focusable by the user
      role="presentation"
      style={{ display: "block", position: "relative" }}
      onFocus={() => updatePresence({ fieldId: id })}
      onBlur={() => updatePresence({ fieldId: undefined })}
    >
      <div id={`portal-mount-${id}`} />
      {children}
    </div>
  )
}
